import {createSlice} from "@reduxjs/toolkit";
import {postVikas} from "./VikasFetch";

const initialState = {
    isLoading:false,
    error:'',
    vikas: [],

}
const VikasSlice = createSlice({
    name: 'vikas',
    initialState,
    reducers:{},
    extraReducers:{
        [postVikas.pending.type]: (state) => {
            state.isLoading = true
        },
        [postVikas.fulfilled.type]:(state, action)=>{
            state.isLoading = false
            state.error = ''
            state.vikas = action.payload
        },
        [postVikas.rejected.type]:(state, action)=>{
            state.isLoading = false
            state.error = action.payload
        },


    }
})
export const {} = VikasSlice.actions

export default VikasSlice.reducer
